<template>
	<el-container>
		<el-main>
			<el-row>
				<el-col :span="24">
					<application-tab-component />
				</el-col>
			</el-row>
		</el-main>
	</el-container>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import ApplicationTabComponent from '@/components/ApplicationTabComponent.vue';
import TabsDictionary from '@/variables/tabs';
import store from '@/store';
import ApplicationTab from '@/models/ApplicationTab';

@Options({
	components: {
		ApplicationTabComponent
	}
})
export default class Index extends Vue {

	mounted() {
		const t = store.getters.tab;

		if (!t) {
			const ordersTab = TabsDictionary.orders;
			store.commit('addTab', ordersTab);
			const newTab = store.getters.newlyAddedTab as ApplicationTab;
			store.commit('changeTab', newTab.id);
		}
	}

}
</script>